import React, { useEffect, useState } from "react";
import bg_image from "../assets/banner_contact.jpg";
import bg_image_mobile from "../assets/mobile_banner.jpg";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import toast from "react-hot-toast";
// import axios from "axios";
const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const collectinput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    // remove error while typing
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    // Name validation
    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    } else if (form.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }
    // Email validation
    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      newErrors.email = "Invalid email address";
    }
    // Message validation
    if (!form.message.trim()) {
      newErrors.message = "Message is required";
    } else if (form.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formsubmit = async (e) => {
    e.preventDefault();
    // stop submit if validation fails
    if (!validateForm()) return;
    try {
      setIsSubmitting(true);
      // const { data } = await axios.post("/contactmail", form);
      // toast.success(data.message);
      toast.success("From Submitted successfully")
      // Reset form
      setForm({
        name: "",
        email: "",
        message: "",
      });

      setErrors({});
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  return (
    <div className="bg-[#e9f6e8] font-lexend">
      <div className="w-full  font-lexend lg:pt-10 md:pt-16 xl:pt-0 relative overflow-hidden">
        <div className="w-full  -z-30">
          <img src={bg_image} alt="" className="w-full md:block hidden " />
          <img
            src={bg_image_mobile}
            alt=""
            className="w-full md:hidden block "
          />
        </div>
        <div className="flex flex-col justify-center items-center md:items-start w-full h-full absolute top-0  left-1/2 -translate-x-1/2 -translate-y- md:max-w-[80%] xl:max-w-[78rem] 2xl:max-w-[80rem] 3xl:max-w-[88rem] mx-auto">
          <div className="lg:px-0 px-8 xs:px-4 bg-white  md:bg-transparent py-4 md:py-0  lg:pt-10 md:pt-16">
            <h1 className="2xl:text-6xl xl:text-5xl lg:text-4xl sm:text-center sm:text-3xl text-4xl xs:text-2xl 2xl:leading-[64px]  text-[#3a683f] font-extralight uppercase">
              CONTACT US
            </h1>
            <p className="lg:mt-2 font-lexend font-light sm:text-center text-[#6d6d6d] text-[14px] md:text-[18px] xl:text-[22px]">
              Here to help you find the right rest
            </p>
          </div>
        </div>
      </div>
      <div className=" font-lexend lg:pt-10 pt-10 2xl:pt-32 2xl:pb-36 xl:pb-28 lg:pb-24 md:pb-20 pb-10 grid lg:grid-cols-2 grid-cols-1 xl:gap-10 gap-5 md:max-w-[80%] w-[90%] xl:max-w-[78rem] 2xl:max-w-[80rem] 3xl:max-w-[88rem] mx-auto relative  overflow-hidden">
        <div className="flex flex-col justify-between lg:gap-0 gap-4">
          <div>
            <h2 className="2xl:text-6xl xl:text-5xl lg:text-4xl text-3xl  xs:text-2xl 2xl:leading-[64px]   text-[#3a683f] font-light">
              Need guidance?
            </h2>
            <p className="text-[18px] md:text-[20px] xl:text-[24px] 3xl:text-[28px] text-[#3a683f] font-light mt-3 md:leading-[38px]">
              Whether you’re looking
              <br />
              for the right mattress or need support
              <br />
              after your purchase, we’re here to help.
              <br />
            </p>
          </div>
          <div className="">
            <h2 className="2xl:text-[40px] text-3xl xs:text-2xl 2xl:leading-[64px]  text-[#3a683f] font-light">
              Location
            </h2>
            <p className="text-base md:text-[18px] lg:text-[20px] xl:text-[22px] text-[#3a683f] font-light mt-2 md:leading-[38px]">
              SY NO.148 TSIIC, Kallakal, Telangana 502336.
              <br />
              <a href="mailto:sales@livoncomforts.com">
                sales@livvoncomforts.com
              </a>
              <br />
              <a href="tel:+919458419999">Phone: (+91) 9458419999</a>
              <br />
            </p>
          </div>
          <div className="">
            <h2 className="2xl:text-[40px]  text-3xl xs:text-2xl 2xl:leading-[64px]  text-[#3a683f] font-light">
              Follow Us
            </h2>
            <div className=" pt-2  text-center flex flex-col lg:text-right items-start">
              <ul className="flex justify-center lg:justify-end items-center gap-5">
                <li className="bg-[#2a552f] w-8 h-8 rounded-full flex justify-center items-center">
                  <FacebookOutlinedIcon sx={{ color: "#fff" }} />
                </li>
                <li className="bg-[#2a552f] w-8 h-8 rounded-full flex justify-center items-center">
                  <InstagramIcon sx={{ color: "#fff" }} />
                </li>
                <li className="bg-[#2a552f] w-8 h-8 rounded-full flex justify-center items-center">
                  <XIcon sx={{ color: "#fff" }} />
                </li>
                <li className="bg-[#2a552f] w-8 h-8 rounded-full flex justify-center items-center">
                  <YouTubeIcon sx={{ color: "#fff" }} />
                </li>
                <li className="bg-[#2a552f] w-8 h-8 rounded-full flex justify-center items-center">
                  <LinkedInIcon sx={{ color: "#fff" }} />
                </li>
              </ul>
              <p className=" pt-2 sm:text-[14px] text-[15px] xl:text-[24px] 3xl:text-[28px] text-[#508656] font-lexend font-light">
                &copy; 2026 privacy policy
              </p>
            </div>
          </div>
        </div>
        <div>
          <p className="text-[18px] md:text-[20px] xl:text-[24px] 3xl:text-[26px] text-[#3a683f] font-light mt-2 xl:leading-[38px]">
            Share your details and we’ll reach out to you
          </p>
          <form
            onSubmit={formsubmit}
            className="bg-white xl:p-6 p-4  flex flex-col xl:gap-6 gap-6 sm:gap-4  rounded-[10px] md:mt-6 mt-4"
          >
            <div>
              <input
                placeholder="Enter your name *"
                type="text"
                name="name"
                value={form.name}
                onChange={collectinput}
                className="w-full border font-light border-[#b1b1b1] xl:text-[21px] lg:text-lg text-base  rounded-[10px] sm:py-2 py-3 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]"
              />
              {errors.name && <p className="text-red-500 mt-1 font-lexend font-light">{errors.name}</p>}
            </div>
            <div>
              <input
                placeholder="Enter a valid Email address *"
                name="email"
                value={form.email}
                onChange={collectinput}
                type="email"
                className="w-full border font-light  border-[#b1b1b1] xl:text-[21px] lg:text-lg text-base rounded-[10px] sm:py-2 py-3 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]"
              />
              {errors.email && (
                <p className="text-red-500 mt-1 font-lexend font-light">{errors.email}</p>
              )}{" "}
            </div>
            <div>
              {" "}
              <textarea
                placeholder="Enter your message*"
                rows={7}
                name="message"
                type="text"
                value={form.message}
                onChange={collectinput}
                className="w-full border font-light resize-none border-[#b1b1b1] xl:text-[21px] lg:text-lg text-base rounded-[10px] sm:py-2 py-3 px-4  placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]"
              />
              {errors.message && (
                <p className="text-red-500 mt-1 font-lexend font-light">{errors.message}</p>
              )}{" "}
            </div>
            <button
              disabled={isSubmitting}
              className="text-[#2a552f] bg-[#f4e390] sm:text-base font-semibold  lg:text-[24px] md:text-[22px] xl:text-[28px] font-lexend xl:py-2.5 py-2 text-center rounded-lg lg:w-[175px] w-32"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
